import { helperApi } from "../api/helperApi";
import { getToken } from "../utils/getToken";

export const helperService = {
  getShortenLink: async (value: string): Promise<string | null> => {
    try {
      const token = getToken();
      if (!token) return null;
      if (value) {
        const response = await helperApi.getShortenLink(token, value);
        return response.data.result;
      }
      return null;
    } catch (error) {
      console.error("Failed to get shorten link:", error);
      return null;
    }
  },
  getPrimaryDomainByBrandId: async (
    brandId: string
  ): Promise<string | null> => {
    try {
      if (brandId) {
        const response = await helperApi.getPrimaryDomainByBrandId(brandId);
        let domain = response.data.result[0].HTTPAlias;

        if (domain.endsWith("/")) {
          domain = domain.slice(0, -1);
        }

        return domain;
      }
      return null;
    } catch (error) {
      console.error("Failed to get Primary Domain:", error);
      return null;
    }
  },
};
